export default __webpack_public_path__ + "guide-buttone0311b.png";